let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ljS4a")).then(() => parcelRequire('5NaVN'));